import React from 'react';
import { FormControl, FormErrorMessage, FormLabel, Select } from '@chakra-ui/react';
import { Controller, useFormContext } from 'react-hook-form';

import { UF_SELECT_OPTIONS } from '../../../../../constants/ufs';

/**
 * Dropdown reusavel de UF (sigla 2 letras). Schema-extension v3 elo 3.
 *
 * Diferenca do dropdown ja existente em `StepEmpresa.junta_comercial_estado`:
 * aquele usa `UF_NOME_SELECT_OPTIONS` (nome do estado como value, ex: "Goias")
 * pra compat com campo legacy de texto livre. Este usa `UF_SELECT_OPTIONS`
 * (sigla como value, ex: "GO") — formato esperado pelos campos v3 estruturados
 * (`endereco.uf`, `foro_uf`, `junta_uf` da PJ socia).
 */
interface UfDropdownProps {
  name: string;
  label?: string;
  isRequired?: boolean;
  placeholder?: string;
  controlMb?: number;
}

export const UfDropdown = ({
  name,
  label = 'UF',
  isRequired,
  placeholder = 'Selecione',
  controlMb,
}: UfDropdownProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormControl isInvalid={!!fieldState.error} isRequired={isRequired} mb={controlMb}>
          <FormLabel fontWeight="bold" mb={1} mr={3} htmlFor={name}>
            {label}
          </FormLabel>
          <Select id={name} placeholder={placeholder} {...field} value={field.value ?? ''}>
            {UF_SELECT_OPTIONS.map(opt => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </Select>
          {fieldState.error?.message && (
            <FormErrorMessage>{fieldState.error.message}</FormErrorMessage>
          )}
        </FormControl>
      )}
    />
  );
};
